export function formatCurrency(amount: number, currency: string): string {
    return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: currency
    }).format(amount);
}